import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { AccountType } from '@goldwasserexchange/oblis-frontend-utils';
import { GoldIcon } from './icon';
import { goldTwoLineTitleContent } from './title';
import { goldAdvantages } from './advantages';

export const detailedAccountTypeLabelsHeadingContentGold = (
  <>
    <TopModel name={`HeadingSectionIllustrationContent-${AccountType.RTO}-section`}>
      {GoldIcon}
    </TopModel>
    <TopModel name={`HeadingSectionTitleContent-${AccountType.RTO}-section`}>
      {goldTwoLineTitleContent}
    </TopModel>
    {goldAdvantages}
  </>
);
